import { IntegrationObjectStatus } from 'types/types';

import { useUserDataContext } from 'components/UserDataContext/context';
import { ROLES } from 'utils/consts/roles';
import { useGetPermission } from 'utils/hooks/useGetPermission';

import styles from './CerberusIntegrationError.module.scss';

interface IProps {
  status?: IntegrationObjectStatus;
  showMessage?: boolean;
}

export const CerberusIntegrationError: React.FC<IProps> = ({ status, showMessage }) => {
  const { userData } = useUserDataContext();
  const hasPermission = useGetPermission(ROLES.cerberus, userData);

  const hasAlarm =
    showMessage ||
    (status &&
      [IntegrationObjectStatus.EXTERNAL_SYSTEM_ERROR, IntegrationObjectStatus.NOT_FOUND].includes(
        status
      ));

  return (
    (hasPermission && hasAlarm && (
      <p className={styles.wrapper}>
        <i>Неактуальная ссылка на Цербер</i>
      </p>
    )) ||
    null
  );
};
